import apiDietPaymentProcessor from "./apiDietPaymentProcessor"
import { TrackingManager } from "../../../common/js/services/tracking/trackingManager"

// Brand-specific upsell component extended from
// common upsell component with global functionality
export default (commonUpsell) =>
  ({ offerPath, paymentsPath, paymentsFailPath, paymentsSuccessPath, sendOffPath } = {}) => ({
    // Init common upsell functionality

    ...commonUpsell({
      upsellOfferType: "shopping_list_and_premium",
      offerPath,
      paymentsPath,
      paymentsFailPath,
      paymentsSuccessPath,
      sendOffPath,
    }),

    isPaymodeModalNeeded: false,
    isPaymodeModalOpen: false,
    chosenPaymentMethod: null,
    internalTracker: new TrackingManager(
      window.trackingConfig.enabledTrackingServices,
      pipelineConfig,
    ),

    init() {
      this.commonInitUpsell()

      window.addEventListener("pageshow", (event) => {
        if (event.persisted) {
          this.isLoading = false
          this.chosenPaymentMethod = null
        }
      })

      if (
        !this.store.values.lastPaymentMethod ||
        this.store.values.lastPaymentMethod !== "primer" ||
        !this.store.values.isCardSaved
      ) {
        this.isPaymodeModalNeeded = true
      }
    },

    handlePayment(paymode) {
      const { handleCheckoutAndRedirect } = apiDietPaymentProcessor

      // Handle card-save payments
      if (!paymode && !this.isPaymodeModalNeeded) {
        this.isLoading = true
        const paymentParamsCardSave = {
          successStepPath: paymentsSuccessPath,
          failedStepPath: paymentsFailPath,
          paymentMethod: "primer",
          restrictCardSave: false,
          checkoutTemplate: "yg-ac-pipe",
        }

        handleCheckoutAndRedirect(paymentParamsCardSave)
        return
      }
      // Open up modal if there is no paymode
      if (!paymode && this.isPaymodeModalNeeded) {
        this.isPaymodeModalOpen = true

        return
      }

      // Handle payments that doesn't have save-card
      this.chosenPaymentMethod = paymode
      this.store.values.lastPaymentMethod = paymode
      this.isLoading = true
      const paymentParamsWithoutCardSave = {
        successStepPath: paymentsSuccessPath,
        failedStepPath: paymentsFailPath,
        paymentMethod: paymode,
        restrictCardSave: true,
        checkoutTemplate: "yg-ac-pipe",
      }

      handleCheckoutAndRedirect(paymentParamsWithoutCardSave)
    },

    handleContinue() {
      if (this.store.values.lastPaymentMethod && this.store.values.lastPaymentMethod === "primer") {
        this.store.values.isCardSaved = true
      }

      this.internalTracker.trackClick({
        clickName: this.upsellEventName["shopping_list_and_premium"]["continue"],
      })

      this.thankYouContinue()
    },

    handleModalClose() {
      this.isPaymodeModalOpen = false
    },

    getSpinnerStatus(paymentMethod) {
      if (!this.isLoading) return false
      if (this.chosenPaymentMethod !== paymentMethod) return false

      return true
    },
  })
